{{ data.message }}
<ng-container *ngFor="let action of data?.actions">
  <button mat-button color="accent" class="snackbar-action" (click)="doAction(action)">{{ action }}</button>
</ng-container>
